<template>
  <div class="v-container">
    <div class="v-page-header">地域数据管理</div>
    <div class="v-header">
      <el-button @click="showAddEditDistrict" size="small" type="primary">新增县级</el-button>
      <div>
        <el-select v-loading="wxLoading" v-model="shopId" placeholder="筛选小程序" style="width: 200px; margin-right: 5px" size="mini">
          <el-option v-for="item in wxList" :value="item.id" :key="item.id" :label="item.name"></el-option>
        </el-select>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table :data="lists" row-key="id" :tree-props="{ children: 'child' }" default-expand-all height="100%" size="small" border>
        <el-table-column label="城市名称" prop="name" />
        <el-table-column label="所属程序" width="150">
          <span v-if="scope.row.level == 1" slot-scope="scope">{{ scope.row.shop_name }}</span>
        </el-table-column>
        <el-table-column label="排序" width="100" prop="sort" />

        <el-table-column align="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.level == 1" @click="showAddEditStreet(scope.row.id)" size="min" class="v-ml-5" type="primary">新增镇级</el-button>
            <el-button v-if="scope.row.level == 2" @click="showAddEditArea(scope.row.id)" size="min" class="v-ml-5" type="success">新增村级</el-button>
            <el-button @click="showEdit(scope.row)" size="min" class="v-ml-5" type="warning">编辑</el-button>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <add-edit-district v-if="isShowAddEditDistrict" :show.sync="isShowAddEditDistrict" :row="row" :wx-list="wxList" @success="getList"></add-edit-district>
    <add-edit-street v-if="isShowAddEditStreet" :show.sync="isShowAddEditStreet" :row="row" :pid="pid" @success="getList"></add-edit-street>
    <add-edit-area v-if="isShowAddEditArea" :show.sync="isShowAddEditArea" :row="row" :pid="pid" @success="getList"></add-edit-area>
  </div>
</template>

<script>
import addEditDistrict from './components/add-edit-district';
import addEditStreet from './components/add-edit-street';
import addEditArea from './components/add-edit-area';

export default {
  components: { addEditDistrict, addEditStreet, addEditArea },

  data() {
    return {
      loading: false,
      lists: [],
      row: null,
      wxLoading: false,
      wxList: [],
      shopId: '',
      pid: 0,
      isShowAddEditDistrict: false,
      isShowAddEditStreet: false,
      isShowAddEditArea: false,
    };
  },
  created() {
    this.getWxList();
    this.getList();
  },

  methods: {
    async getWxList() {
      this.wxLoading = true;
      try {
        let res = await this.api.shop.lists();
        this.wxList = res.data;
      } catch (e) {
        console.error(e);
      }
      this.wxLoading = false;
    },

    async getList() {
      this.loading = true;
      try {
        let res = await this.api.regionAdmin.adminRegionLists({ shop_id: this.shopId });
        res.data.forEach((item) => {
          item.children = item.childList;
        });
        this.lists = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    reset() {
      this.shopId = '';
      this.getList();
    },

    showAddEditDistrict() {
      this.row = null;
      this.isShowAddEditDistrict = true;
    },

    showAddEditStreet(pid) {
      this.row = null;
      this.pid = pid;
      this.isShowAddEditStreet = true;
    },

    showAddEditArea(pid) {
      this.row = null;
      this.pid = pid;
      this.isShowAddEditArea = true;
    },

    showEdit(row) {
      this.row = row;
      if (row.level == 1) {
        this.isShowAddEditDistrict = true;
      }
      if (row.level == 2) {
        this.isShowAddEditStreet = true;
      }
      if (row.level == 3) {
        this.isShowAddEditArea = true;
      }
    },

    //删除
    async doDelete(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.regionAdmin.delete({ id: row.id });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: space-between;
}
</style>
